import React from 'react';
import database from '../../../database.js';
import loading from '../../../img/loading.svg'
import ytLogo from '../../../img/yt-logo.png';
import test from '../../../img/test.png';
import { Button } from 'react-bootstrap';


import anxietyFormulations from '../../../img/Library Formulations/anxietyformulation.png';
import conductFormulations from '../../../img/Library Formulations/conductformulation.png';
import depressionFormulations from '../../../img/Library Formulations/depressionformulation.png';
import eatingFormulations from '../../../img/Library Formulations/eatingformulation.png';


export default class extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      title: "",
      body: null,
      link: "",
      image: null,
      loaded: false
    }
  }
  componentWillMount() {
    database.collection("learnSections").doc(this.props.id).get().then(function(doc) {
        console.log(doc.data());

        this.setState({
          title: doc.data().title,
          points: doc.data().points,
          link: doc.data().link,
          quizLink: doc.data().quizLink,
          order: doc.data().order,
          image: doc.data().image,
          body: {
            __html: doc.data().body
          },
          loaded: true
        });
        console.log(doc.data().points)
      }.bind(this));
  }
  render() {
    let formulation = null;

    if(this.state.title === "Anxiety ") {
      formulation = anxietyFormulations;
    } else if(this.state.title === "Conduct Disorder ") {
      formulation = conductFormulations;
    } else if(this.state.title === "Depression ") {
      formulation = depressionFormulations;
    } else if(this.state.title === "Eating Problems ") {
      formulation = eatingFormulations;
    }


    if(this.state.loaded) {
        let pointlist = [];
        let pointLength = (this.state.points)?this.state.points.length:0;
        for (var i = 0; i < pointLength; i++) {
          pointlist.push(
              <li>{this.state.points[i]}</li>);
        }


        let videoButton = null;
        if (this.state.link !== '') {
          videoButton =<Button target="_blank" className="option-btns" href={this.state.link}> Learn more, watch this video <img width="25px" src={ytLogo} alt="Watchable Video"/></Button>
        }

        let quizLinkButton = <Button className="option-btns" target='_blank' href={this.state.quizLink}>Test your understanding  <img width="25px" src={test}/></Button>;
        return (
          <div className="container library-topic-container"  style={{"paddingTop":"25px"}}>
            <div className="jumbotron">
              <div className="page-header" style={{
                "margin-top":"0px"
              }}>
                <div>
                  <Button href="/youth/library" className="library-topic-return" >⏎ Back to Topic List</Button><br/>
                  {videoButton} <br />
                  { this.state.quizLink ? quizLinkButton : ""}
                </div>
                <img className="spike-img" alt={this.state.image.substring(16)} src={this.state.image.substring(0,16) + "title/" + this.state.image.substring(16)} />
              </div>
              <div>
                <img className="formulation-image" width="600px" src={formulation}/>  
             </div>
              <div className="panel">
                <div className="topic-panel-body panel-body" dangerouslySetInnerHTML={this.state.body} />
              </div>
              <Button href="/youth/library" className="library-topic-return" >Learn about another topic</Button>
            </div>
          </div>
        )
      } else {
        return (
          <div className="library-topic-loading">
            <img src={loading} />
          </div>
        )
      }
    }

}



// WEBPACK FOOTER //
// ./src/components/Library/Topic/TopicView.js